module.exports = __webpack_public_path__ + "b4daae02117147ee4527d69f42f50103.jpg";